import React from "react";
import "./styles.css";
import Board from "../../components/Board";

const Home = (props) => {
  return (
    <div>
      <Board />
    </div>
  );
};

export default Home;
